import { useContext, useEffect, useState } from "react";
import { StyleContext } from "../../providers/StyleContextProvider";
import { AuthContext } from "../../providers/AuthContextProvider";
import { LoggedRecruiter } from "../../models/LoggedRecruiter";
import useErrorPage from "../../hooks/useErrorPage";
import { getCoverLetter } from "../../services/RecruiterService";
import { ApplicationPopUpLoader } from "../Loaders/ApplicationPopUpLoader";

interface Props {
    jobApplicationId: number;
}

export const CoverLetterTab: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const tabStyles = styleContext.getComponentStyle("applicationStatusTabs");  
    const styles = tabStyles.coverLetterTab;          
    const authContext = useContext(AuthContext);  
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();    
    const [coverLetter, setCoverLetter] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [toErrorPage] = useErrorPage();

    useEffect(() => {
        getCandidateCoverLetter(props.jobApplicationId);
    }, []);

    async function getCandidateCoverLetter(jobApplicationId: number) {    
        setLoading(true);
        await getCoverLetter(jobApplicationId, recruiter!.recruiterId, recruiter!.token)
        .then((response: string) => {
            setCoverLetter(response);
            setLoading(false);
        })
        .catch((error) => {            
            toErrorPage(error);
        });
    }

    return (
        <>
            <div style={styles.rowWrapper}>
                <div style={styles.title}>Cover Letter</div>
            </div>
            {loading ? <ApplicationPopUpLoader/> :
                <div style={styles.coverLetter}>
                    <div 
                        style={styles.coverLetter.text}
                        dangerouslySetInnerHTML={{ __html: coverLetter }}
                    />
                </div>
            }
        </>
    )
}